import { ref, onMounted, onUnmounted } from 'vue'

let timer = null
let useCount = 0

/** @description 活动倒计时等场景刷新间隔（展示毫秒第一位） */
const GLOBAL_TIMER_TICK_MS = 100

// 仅在客户端共享响应式状态，避免 SSR 跨请求污染
const clientNow = import.meta.client ? ref(Date.now()) : null

/**
 * @description 全局共享的时间钩子，用于性能优化（避免多个组件开启多个定时器）
 * @returns {Ref<number>} 当前时间戳
 */
export const useGlobalTimer = () => {
  // 服务端渲染时，每次调用生成一个新的时间（或者也可以用 computed 返回 Date.now()），防止状态被污染
  const now = import.meta.client ? clientNow : ref(Date.now())

  const startTimer = () => {
    if (!import.meta.client || timer) return

    const tick = () => {
      const currentTime = Date.now()
      if (clientNow) {
        clientNow.value = currentTime
      }

      const delay = GLOBAL_TIMER_TICK_MS - (currentTime % GLOBAL_TIMER_TICK_MS)
      timer = setTimeout(tick, delay > 0 ? delay : GLOBAL_TIMER_TICK_MS)
    }

    timer = setTimeout(tick, GLOBAL_TIMER_TICK_MS - (Date.now() % GLOBAL_TIMER_TICK_MS))
  }

  const stopTimer = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  onMounted(() => {
    useCount++
    if (useCount > 0) {
      startTimer()
    }
  })

  onUnmounted(() => {
    useCount--
    if (useCount <= 0) {
      stopTimer()
    }
  })

  return {
    now,
  }
}
